var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('a',{attrs:{"href":"https://www.andesonline.com"}},[_c('img',{staticClass:"main-logo img-fluid",attrs:{"src":require("@/img/andes_logo.jpg"),"alt":"logo-andes"}})])])])])
}]

export { render, staticRenderFns }